import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setSelectedCategory } from "../../redux/actions";

export const Products = () => {
  const dispatch = useDispatch();
  const { items, selectedCategory } = useSelector((state) => state.products);

  const [visibleCount, setVisibleCount] = useState(6);

  useEffect(() => {
    setVisibleCount(6);
  }, [selectedCategory]);

  const categories = ["Semua", ...new Set(items.map((p) => p.category))];

  const filteredProducts =
    selectedCategory === "Semua"
      ? items
      : items.filter((p) => p.category === selectedCategory);

  const visibleProducts = filteredProducts.slice(0, visibleCount);

  return (
    <section id="produk" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Produk Kami</h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto mb-4"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mb-8">
            Setiap produk dibuat secara handmade dengan ketelitian dan penuh
            cinta di setiap prosesnya.
          </p>

          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => dispatch(setSelectedCategory(cat))}
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  selectedCategory === cat
                    ? "bg-pink-600 text-white shadow-lg"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {visibleProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2"
            >
              <div className="h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                />
              </div>

              <div className="p-6">
                <span className="text-sm text-pink-600 font-medium bg-pink-50 px-3 py-1 rounded-full">
                  {product.category}
                </span>

                <h3 className="text-xl font-bold text-gray-900 mt-3 mb-2">
                  {product.name}
                </h3>

                <p className="text-gray-600 text-sm mb-3">
                  {product.description}
                </p>

                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold text-pink-600">
                    {product.price}
                  </span>

                  <a
                    href="#kontak"
                    className="bg-pink-600 text-white px-4 py-2 rounded-lg hover:bg-pink-700 transition-colors text-sm font-medium"
                  >
                    Pesan
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredProducts.length > visibleCount && (
          <div className="text-center mt-12">
            <button
              onClick={() => setVisibleCount(filteredProducts.length)}
              className="px-8 py-3 bg-pink-600 text-white rounded-full font-medium hover:bg-pink-700 transition-all"
            >
              Lihat Lebih Banyak
            </button>
          </div>
        )}
      </div>
    </section>
  );
};
